import { PaymentMethodBrandsTypeEnum } from '@pm/graphql';

import {
  AmexIcon,
  CardIcon,
  DinersClubIcon,
  DiscoverIcon,
  JcbIcon,
  MastercardIcon,
  UnionPayIcon,
  VisaIcon,
} from '@pm/icons';

type StripeCreditCardIconProps = {
  brandType: PaymentMethodBrandsTypeEnum | null;
};

export const StripeCreditCardIcon = ({
  brandType,
}: StripeCreditCardIconProps) => {
  switch (brandType) {
    case PaymentMethodBrandsTypeEnum.Amex:
      return <AmexIcon />;
    case PaymentMethodBrandsTypeEnum.Diners:
      return <DinersClubIcon />;
    case PaymentMethodBrandsTypeEnum.Discover:
      return <DiscoverIcon />;
    case PaymentMethodBrandsTypeEnum.Jcb:
      return <JcbIcon />;
    case PaymentMethodBrandsTypeEnum.Mastercard:
      return <MastercardIcon />;
    case PaymentMethodBrandsTypeEnum.Unionpay:
      return <UnionPayIcon />;
    case PaymentMethodBrandsTypeEnum.Visa:
      return <VisaIcon />;
    case PaymentMethodBrandsTypeEnum.Unknown:
      return <CardIcon />;
    default:
      return <CardIcon />;
  }
};
